export default __webpack_public_path__ + "static/media/defient_tile-mobile.png.webp";